// TNK 가입완료 추적 스크립트
const join_complete_tnk = () => {
    if (typeof window.TnkSession !== 'undefined' && typeof window.TnkSession.actionCompleted === 'function') {
      window.TnkSession.actionCompleted()
    }
  }
  
export { join_complete_tnk }